import { useRef } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

export default function Services() {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const { scrollLeft, clientWidth } = scrollRef.current;
      scrollRef.current.scrollTo({
        left:
          direction === "left"
            ? scrollLeft - clientWidth
            : scrollLeft + clientWidth,
        behavior: "smooth",
      });
    }
  };

  return (
    <div id="services" className="bg-gradient-to-r from-red-300 to-red-900 mt-28 px-4 py-20 lg:h-[600px] relative">
      {/* Heading */}
      <h1 className="text-center text-4xl lg:text-5xl font-bold text-white">
        Common Pest Control
      </h1>

      {/* Card Container */}
      <div
        ref={scrollRef}
        className="mt-16 flex gap-8 items-center justify-start
        overflow-x-auto scroll-smooth snap-x snap-mandatory
        md:overflow-visible md:flex-wrap md:justify-center"
      >
        {/* Card */}
        {[
          {
            img: "./Cockroach-1.jpg",
            title: "Cockroach",
            desc: "Disease-spreading insects that thrive in warm, humid environments.",
          },
          {
            img: "./Spiders.jpg",
            title: "Spider",
            desc: "We provide effective control solutions against spiders and insects.",
          },
          {
            img: "./Termites.jpg",
            title: "Termites",
            desc: "Termites are destructive pests. Surface treatments provide only temporary relief.",
          },
          {
            img: "./Rodents.jpg",
            title: "Rodent",
            desc: "We provide effective rodent control solutions for rats, mice, bandicoots, etc.",
          },
        ].map((item, index) => (
          <div
            key={index}
            className="snap-center flex-shrink-0 w-[80%] sm:w-[60%] md:w-[35vh] border rounded-3xl flex flex-col items-center hover:shadow-2xl bg-white"
          >
            <img
              src={require(`${item.img}`)}
              alt={item.title}
              className="h-[85px] w-[85px] border-4 rounded-full mt-10"
            />
            <h1 className="mt-5 font-bold text-xl">{item.title}</h1>
            <p className="mt-5 text-zinc-600 text-center text-sm px-4 pb-6">
              {item.desc}
            </p>
          </div>
        ))}
      </div>

      {/* Arrow Buttons (visible only on mobile) */}
      <div className="flex justify-center mt-6 gap-6 md:hidden">
        <button
          onClick={() => scroll("left")}
          className="p-3 bg-white rounded-full shadow-md hover:bg-gray-200"
        >
          <FaArrowLeft />
        </button>
        <button
          onClick={() => scroll("right")}
          className="p-3 bg-white rounded-full shadow-md hover:bg-gray-200"
        >
          <FaArrowRight />
        </button>
      </div>
    </div>
  );
}
